import Vue from 'vue';
import * as Sentry from '@sentry/vue';

const environment = process.env.NODE_ENV || 'development';
const enabled = process.env.MIX_SENTRY_VUE_ENABLED === 'true' || false;

if (enabled && environment === 'production') {
  Sentry.init({
    Vue,
    dsn: process.env.MIX_SENTRY_VUE_DSN,
    environment: process.env.MIX_SENTRY_ENVIRONMENT || 'staging',
    release: process.env.NODE_SENTRY_RELEASE || process.env.MIX_SENTRY_RELEASE,
    ignoreErrors: [
      // Instagram/Facebook iOS in-app browser autofill injection
      "Can't find variable: _AutofillCallbackHandler",
    ],
    integrations: [
      new Sentry.BrowserTracing({
        tracePropagationTargets: [
          'unihomes.test',
          /^https:\/\/unihomes.co.uk/,
          /^https:\/\/www.unihomes.co.uk/,
          /^https:\/\/staging.unihomes.co.uk/,
          /^\//,
        ],
      }),
    ],
    tracesSampleRate: process.env.MIX_SENTRY_TRACES_SAMPLE_RATE || 0.25,
    tracingOptions: {
      trackComponents: true,
    },
    // Vue specific
    logErrors: environment === 'production' ? false : true,
    attachProps: true,
    attachStacktrace: true,
  });

  if (window.config?.landlord?.id) {
    Sentry.setUser({ id: window.config?.landlord?.id });
  }
}
